<div class="container container-profile container-profile-company p-3 bg-white">

  <div class="d-flex w-100">
    <a routerLink="/company/applications" class="btn btn-primary">
      {{ 'Back' | translate }}
    </a>
  </div>

  <div class="page-header">
    <h3 class="page-title">{{ 'Application for job' | translate }}: {{ application.jobPosting?.title}}</h3>
  </div>

  <div class="page-body d-flex flex-column g-3">

    <div class="card">
      <div class="card-body">

        <div class="row">
          <div class="col-sm-6">
            <div class="rounded rounded-full" *ngIf="application?.applicant?.avatarUri">
              <img [src]="application.applicant!.avatarUri" class="avatar-image img-256 rounded-circle" />
            </div>
          </div>

          <div class="col-sm-6" *ngIf="application.applicant">
            <div class="d-flex flex-column">
              <div class="row">
                <div class="col col-sm-6">{{ 'Name' | translate }}</div>
                <div class="col col-sm-6">{{ application.applicant.firstName }} {{ application.applicant.lastName }}</div>
              </div>
              <div class="row">
                <div class="col col-sm-6">{{ 'Email' | translate }}</div>
                <div class="col col-sm-6"><a href="mailto:{{application.applicant.emailAddress}}">{{ application.applicant.emailAddress }}</a></div>
              </div>
              <div class="row" *ngIf="application.applicant.phoneNumber">
                <div class="col col-sm-6">{{ 'Phone' | translate }}</div>
                <div class="col col-sm-6">{{ application.applicant.phoneNumber }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header">
        <h3 class="card-title">{{ 'Motivation' | translate}}</h3>
      </div>
      <div class="card-body bg-white p-3">{{ application.motivationText }}</div>
    </div>

  </div>

</div>
